const reportWebVitals = (onPerfEntry?: any) => {
  // Web vitals reporting disabled for now
};

export default reportWebVitals;
